/* EmojiPickerVirtualItems.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vb1xp%7Bheight%3A150px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1z0ZYFdnbC%20%3Ediv%7Bflex-grow%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UPrH0dnbC%20%3Ediv%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ims5nIZbP%20%3Ediv%7Bflex-basis%3Aauto%7D");
import type { ReactNode } from 'react';
import Spinner from '@atlaskit/spinner';
import EmojiPickerCategoryHeading, { type Props as CategoryHeadingProps } from './EmojiPickerCategoryHeading';
import EmojiPickerEmojiRow, { type Props as EmojiRowProps } from './EmojiPickerEmojiRow';
import EmojiPickerNoResults, { type Props as NoResultsProps } from './EmojiPickerNoResults';
import { sizes } from './EmojiPickerSizes';
import type { VirtualItem as VirtualItemContext } from '@tanstack/react-virtual';
const emojiPickerSpinner = null;
export interface RenderItem {
  (context?: VirtualItemContext): ReactNode;
}
export interface VirtualItem<P> {
  height: number;
  props: P;
  renderItem: RenderItem;
}
export abstract class AbstractItem<P> implements VirtualItem<P> {
  readonly height: number;
  readonly props: P;
  constructor(props: P, height: number) {
    this.props = props;
    this.height = height;
  }
  abstract renderItem: RenderItem;
}
export class EmojisRowItem extends AbstractItem<EmojiRowProps> {
  constructor(props: EmojiRowProps) {
    super(props, sizes.emojiRowHeight);
  }
  renderItem = (context?: VirtualItemContext): JSX.Element => <EmojiPickerEmojiRow {...this.props} virtualItemContext={context} />;
}
export class LoadingItem extends AbstractItem<{}> {
  constructor() {
    super({}, sizes.loadingRowHeight);
  }
  renderItem = (): JSX.Element => <div className={ax(["_3iDTPbQ4SZ _39xV02N91d _0jFU0Vb1xp _37wbyuDIqT _0hPCNLDIqT _1z0ZYFdnbC _1UPrH0dnbC _4ims5nIZbP"])}>
			<div>
				<Spinner size="medium" />
			</div>
		</div>;
}
export class CategoryHeadingItem extends AbstractItem<CategoryHeadingProps> {
  constructor(props: CategoryHeadingProps) {
    super(props, sizes.categoryHeadingHeight);
  }
  renderItem = (): JSX.Element => <EmojiPickerCategoryHeading {...this.props} />;
}
export class NoResultsItem extends AbstractItem<NoResultsProps> {
  constructor(props: NoResultsProps) {
    super(props, sizes.noResultsHeight);
  }
  renderItem = (): JSX.Element => <EmojiPickerNoResults {...this.props} />;
}
export const virtualItemRenderer = (rows: VirtualItem<CategoryHeadingProps | EmojiRowProps | NoResultsProps | {}>[], context: VirtualItemContext): JSX.Element => {
  const {
    index,
    key
  } = context;
  const row: VirtualItem<CategoryHeadingProps | EmojiRowProps | NoResultsProps | {}> = rows[index];
  return <div key={key}>{row && row.renderItem(context)}</div>;
};